import { ROUTES } from '@shared/constants';

export const SOCIAL_DOMAINS = {
  GITHUB: 'github.com',
  THREADS: 'threads.net',
  TIKTOK: 'tiktok.com',
  LINKEDIN: 'linkedin.com',
  FACEBOOK: 'facebook.com',
  INSTAGRAM: 'instagram.com',
};

export const PATH_TO_TITLE_PAGE = {
  [ROUTES.PERSONAL_INFORMATION]: 'personal information',
  [ROUTES.EXPERIENCES]: 'experiences',
  [ROUTES.EDUCATION]: 'education',
  [ROUTES.TECHNICAL_SKILLS]: 'skills',
  [ROUTES.CERTIFICATES]: 'certificates',
};
